module.exports = __webpack_public_path__ + "img/workout4.0a30fa9e.jpg";